import LinkToDocusaurus from '../LinkToDocusaurus'
import { Paragraph } from '@eggplant/pattern-library'

// TODO: ETD-7990 add docusaurus link
const ManageAssetsDescription = () =>
  <div>
    <Paragraph>
      View and manage specific assets, or move all assets to another space.
    </Paragraph>
    <span>
      <LinkToDocusaurus path=''>Learn more in the DAI documentation</LinkToDocusaurus>
    </span>
  </div>

export default ManageAssetsDescription
